export default __webpack_public_path__ + "static/media/malaria-icon.216cbcea.png";